import { Block } from '$core/models/block';
import { StaticDataUpdateModel } from '$core/models/static';
import { StaticDataBlockSectionDto, StaticDataUpdateDto } from './static-dto';

export function transformStaticDataDtoToModel(
  dto: StaticDataUpdateDto
): StaticDataUpdateModel {
  let result;

  if (dto.hasOwnProperty('blocks')) {
    result = { ...(dto as StaticDataBlockSectionDto) };
    for (const key in result.blocks) {
      result[key] = new Block(result.blocks[key]);
    }
    delete result.blocks;
  } else {
    result = dto;
  }

  return result;
}
